import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadModernizationPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={
            'モダナイゼーション レガシーシステム刷新 クラウドネイティブ AI駆動開発 DX推進 システム移行 IT投資 デジタルシフト'
          }
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/modernization/done/'}
          title="ご入力いただきありがとうございます | 失敗しないAI時代のモダナイゼーション戦略 | 資料ダウンロード | Aitria（アイトリア）"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
